// removed by extract-text-webpack-plugin
module.exports = {"mcloudLogin":"_1BNDyc2WiM2ZVVaHidvnKz","zoomIn":"_3pLmQe4ZSfXGTTcWSKf0nE","form":"_13pIn2RMUcHgGlS7c4Utos","loginBtn":"_8ppG6ng6bp2RNFtkpF4Kg","loginErr":"_1QMAAX_mg06FEAaDvhyiGP"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login/Login.less
// module id = 967
// module chunks = 0